import { render, staticRenderFns } from "./MortgagesWrapper.vue?vue&type=template&id=62852278&scoped=true&"
import script from "./MortgagesWrapper.vue?vue&type=script&lang=ts&"
export * from "./MortgagesWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./MortgagesWrapper.vue?vue&type=style&index=0&id=62852278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62852278",
  null
  
)

export default component.exports